import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { v4 as uuid } from 'uuid';
import { findIndex, reject } from 'lodash-es';
import cn from 'classnames';
import { safeInvoke, Intent } from '../../../library';
import { flexClasses } from '../../../utilities';
import { AlertProvider } from './alert-provider';
import { Dialog, DialogPositionType, DialogSizeType } from '../../dialog';
import { Buttons, Button } from '../../button';
import { Heading } from '../../type/heading';
export var alert = new AlertProvider();
var alertClasses = {
  MAIN: 'alert'
};
export var AlertContainer = function (_React$Component) {
  _inherits(AlertContainer, _React$Component);
  var _super = _createSuper(AlertContainer);
  function AlertContainer() {
    var _this;
    _classCallCheck(this, AlertContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "id", uuid());
    _defineProperty(_assertThisInitialized(_this), "state", {
      alerts: [],
      isOpen: false
    });
    _defineProperty(_assertThisInitialized(_this), "show", function (options, id) {
      var alert = _this._createAlertOptions(options, id);
      var curIndex = !!id ? findIndex(_this.state.alerts, ['id', id]) : -1;
      if (curIndex === 0) {
        _this.dismiss(_this.state.alerts[curIndex].id);
        window.setTimeout(function () {
          _this.setState(function (prevState) {
            var filteredAlerts = reject(prevState.alerts, ['id', id]);
            return {
              alerts: [alert].concat(_toConsumableArray(filteredAlerts)),
              isOpen: true
            };
          });
        }, 250);
      } else if (curIndex > -1) {
        _this.setState(function (prevState) {
          var filteredAlerts = reject(prevState.alerts, ['id', id]);
          filteredAlerts.splice(curIndex, 0, alert);
          return {
            alerts: filteredAlerts,
            isOpen: true
          };
        });
      } else {
        _this.setState(function (prevState) {
          return {
            alerts: [].concat(_toConsumableArray(prevState.alerts), [alert]),
            isOpen: true
          };
        });
      }
      return alert.id;
    });
    _defineProperty(_assertThisInitialized(_this), "dismiss", function () {
      var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(id) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve) {
                var curIndex = findIndex(_this.state.alerts, ['id', id]);
                if (curIndex < 0) {
                  resolve();
                  return;
                }
                var delay = 0;
                if (curIndex === 0) {
                  _this.setState({
                    isOpen: false
                  });
                  delay = 250;
                }
                window.setTimeout(function () {
                  _this.setState(function (prevState) {
                    var updatedAlerts = reject(prevState.alerts, ['id', id]);
                    return {
                      alerts: updatedAlerts,
                      isOpen: updatedAlerts.length > 0
                    };
                  }, resolve);
                }, delay);
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "clear", _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
      var alertIds, index;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            alertIds = _this.state.alerts.map(function (alert) {
              return alert.id;
            }).reverse();
            index = 0;
          case 2:
            if (!(index < alertIds.length)) {
              _context2.next = 8;
              break;
            }
            _context2.next = 5;
            return _this.dismiss(alertIds[index]);
          case 5:
            index++;
            _context2.next = 2;
            break;
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    _defineProperty(_assertThisInitialized(_this), "getAlerts", function () {
      return _this.state.alerts;
    });
    _defineProperty(_assertThisInitialized(_this), "isAlertActive", function (id) {
      return _this.state.alerts[0] && _this.state.alerts[0].id === id;
    });
    _defineProperty(_assertThisInitialized(_this), "_getDismissHandler", function (alert) {
      return function () {
        safeInvoke(alert.onCancel);
        _this.dismiss(alert.id);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "_getResolveHandler", function (alert, fn) {
      return function (e) {
        safeInvoke(fn);
        safeInvoke(alert.onResolve);
        _this.dismiss(alert.id);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "renderActions", function (alert) {
      if (alert.actions) return alert.actions.map(function (action, index) {
        return React.createElement(Button, {
          key: index,
          intent: action.isPrimary ? alert.intent !== Intent.NONE ? alert.intent : Intent.PRIMARY : Intent.NONE,
          appearance: action.isPrimary ? 'fill' : 'minimal',
          label: action.label,
          onClick: _this._getResolveHandler(alert, action.onClick)
        });
      });
      return React.createElement(Button, {
        appearance: "fill",
        label: alert.confirmText,
        onClick: _this._getResolveHandler(alert),
        intent: alert.intent !== Intent.NONE ? alert.intent : Intent.PRIMARY
      });
    });
    return _this;
  }
  _createClass(AlertContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      alert.on('SHOW', this.show).on('DISMISS', this.dismiss).on('CLEAR', this.clear).connect(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      alert.off('SHOW', this.show).off('DISMISS', this.dismiss).off('CLEAR', this.clear).disconnect(this);
    }
  }, {
    key: "_createAlertOptions",
    value: function _createAlertOptions(options) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "alert-".concat(uuid());
      var defaultProps = {
        cancelText: 'Cancel',
        confirmText: 'OK',
        isCancelable: true,
        isClosedOnOutsideClick: false,
        isClosedOnEscape: false,
        position: DialogPositionType.CENTER,
        size: DialogSizeType.SM
      };
      return _objectSpread(_objectSpread(_objectSpread({}, defaultProps), options), {}, {
        id: id
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        alerts = _this$state.alerts,
        isOpen = _this$state.isOpen;
      if (alerts.length === 0) return null;
      var currentAlert = alerts[0];
      var classNames = cn(alertClasses.MAIN);
      var dismissHandler = this._getDismissHandler(currentAlert);
      return React.createElement(Dialog, {
        className: classNames,
        intent: currentAlert.intent,
        isClosedOnEscape: currentAlert.isClosedOnEscape || currentAlert.isCancelable,
        isClosedOnOutsideClick: currentAlert.isClosedOnOutsideClick && currentAlert.isCancelable,
        isOpen: isOpen,
        onClose: dismissHandler,
        position: currentAlert.position,
        showClose: false,
        size: currentAlert.size
      }, !!currentAlert.title ? React.createElement(Dialog.Header, null, React.createElement(Heading, {
        size: 2
      }, currentAlert.title)) : null, !!currentAlert.body ? React.createElement(Dialog.Body, null, currentAlert.body) : null, React.createElement(Dialog.Footer, null, React.createElement(Buttons, {
        className: flexClasses.justify.end
      }, currentAlert.isCancelable ? React.createElement(Button, {
        appearance: "minimal",
        label: currentAlert.cancelText,
        onClick: dismissHandler
      }) : null, this.renderActions(currentAlert))));
    }
  }]);
  return AlertContainer;
}(React.Component);
_defineProperty(AlertContainer, "displayName", 'AlertContainer');